import { render, staticRenderFns } from "./WithDrawal.vue?vue&type=template&id=66a4f983&"
import script from "./WithDrawal.vue?vue&type=script&lang=js&"
export * from "./WithDrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports